<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="marketKpilist" label="运营投放KPI"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'MarketKpiDefault',
  data() {
    return {
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      this.currentRoute = this.$route.name
      if (this.$route.name === 'marketKpi') this.changeRouter('marketKpilist')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  height: calc(100% - 40px);
  position: relative;
}
</style>
